import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import en from './en'
import zhCN from './zh-CN'

Vue.use(VueI18n)

export const LOCALE_KEY = 'site_locale'
export const DEFAULT_LOCALE = 'en'

export function normalizeLocale(value) {
  if (!value) return DEFAULT_LOCALE
  const v = String(value).toLowerCase()
  if (v.startsWith('zh')) return 'zh-CN'
  return 'en'
}

export function getStoredLocale() {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_KEY) || DEFAULT_LOCALE)
  } catch (e) {
    return DEFAULT_LOCALE
  }
}

export function applyElementLocale(lang) {
  locale.use(lang === 'zh-CN' ? elementZh : elementEn)
}

export function setLocale(i18n, lang) {
  const next = normalizeLocale(lang)
  i18n.locale = next
  applyElementLocale(next)
  try {
    localStorage.setItem(LOCALE_KEY, next)
  } catch (e) { /* ignore */ }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next === 'zh-CN' ? 'zh-CN' : 'en'
  }
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    'zh-CN': zhCN
  },
  silentTranslationWarn: true
})

applyElementLocale(i18n.locale)

export default i18n
